export default __webpack_public_path__ + "static/media/more.58b0035a.svg";